<appTable v-if="shouldRenderConfig && !getIsCimpressProduct" :tableName="name"  v-bind:tableClass="getClassName">
    <slot></slot>
</appTable>